// Mock data & translations for RapidPay landing page (frontend only)

export const ASSETS = {
  logo: "/logos/rapidpay-color.webp",
  card: "/rapidpay-card.png",
};

export const CONTACT = {
  address: "Panamá, Costa del Este, Prime Time Business Tower, Piso 7, Oficina 7B",
  email: "info@rapidpaypro.com",
  phone: "(507) 310-0055",
  phoneHref: "tel:+5073100055",
  whatsapp: "(507) 6821-6898",
  whatsappHref: "https://wa.me/50768216898",
};

export const CLIENT_LOGOS = [
  "TECNOPTY", "Moda+Urbana", "Café Altura", "Viaja365", "FarmaVida", "IslaSurf Co.", "PanaMarket", "Dental Sonrisa",
];

export const PAYMENT_METHODS = [
  { name: "Visa", style: "visa" },
  { name: "Mastercard", style: "mc" },
  { name: "Yappy", style: "yappy" },
  { name: "ACH", style: "ach" },
];

export const SECURITY_BADGES = [
  "3-D Secure 2.0", "Tokenización", "Antifraude IA",
];

export const SECURITY_LOGOS = [
  { src: "/logos/sec_pci.png", alt: "PCI DSS Compliant", h: "h-[52px]" },
  { src: "/logos/sec_visa_secure.png", alt: "Visa Secure", h: "h-[60px]" },
  { src: "/logos/sec_mastercard.png", alt: "Mastercard", h: "h-[60px]" },
  { src: "/logos/sec_capatec.png", alt: "CAPATEC", h: "h-[48px]" },
  { src: "/logos/sec_cciap.png", alt: "Cámara de Comercio, Industrias y Agricultura de Panamá", h: "h-[68px]" },
];

export const translations = {
  es: {
    langName: "Español",
    nav: { products: "Productos", benefits: "Beneficios", payfac: "PayFac", industries: "Industrias", pricing: "Precios", testimonials: "Clientes", contact: "Contacto", login: "Iniciar sesión", signup: "Registrarse" },
    hero: {
      chips: ["Retail", "Turismo", "Servicios", "eCommerce"],
      title1: "Cobrar nunca fue",
      title2: "tan rápido",
      subtitle: "RapidPay es un Facilitador de Pagos (PayFac) ofrecemos métodos de pago alternativo en Panamá, que permite a los comerciantes acceder a una base de consumidores más amplia y ofrece confirmación de pago instantánea.",
      ctaPrimary: "Comenzar ahora",
      ctaSecondary: "Contáctenos",
      trusted: "Negocios que ya cobran con RapidPay",
    },
    benefits: {
      title: "Todo lo que necesitas para cobrar sin complicaciones",
      items: [
        { title: "Afiliación gratis en 5 minutos", desc: "Sin filas ni papeleos interminables para empezar a cobrar." },
        { title: "Sin costos fijos ni mensualidades", desc: "Solo pagas cuando vendes. Así de simple." },
        { title: "Múltiples métodos de pago", desc: "Tarjetas nacionales e internacionales, transferencias locales, billeteras digitales y cuotas.", showMethods: true },
        { title: "Sin burocracia bancaria", desc: "Nosotros nos encargamos del trámite por ti." },
        { title: "Cobra en la moneda que prefieras", desc: "Balboas o dólares, sin complicaciones." },
        { title: "Integración sin conocimientos técnicos", desc: "+90 plataformas listas para conectar, o nuestro propio API y SDK." },
        { title: "Soporte técnico local y bilingüe", desc: "Equipos en la región, no un chatbot." },
        { title: "Cashout a tu Banco Local", desc: "Más de 24 bancos en Panamá y la región." },
      ],
    },
    payfac: {
      label: "¿Qué es un PayFac?",
      title: "Somos un Facilitador de Pagos: te afilias con nosotros, no con el banco.",
      desc: "Un Payment Facilitator (PayFac) es una empresa que ya tiene contrato con los adquirentes y las marcas (Visa, Mastercard) e integra a los comercios bajo su propia cuenta maestra. En lugar de negociar y certificarte directamente con un banco, el comercio se registra en RapidPay y empieza a cobrar.",
      desc2: "RapidPay asume la certificación técnica, el cumplimiento PCI, la prevención de fraude y la conciliación, para que tú te concentres en vender.",
      reasons: [
        { title: "Afiliación en horas, no semanas", desc: "Validamos tus datos y documentos en línea y activamos tu cuenta rápidamente." },
        { title: "Menos papeleo", desc: "Un solo registro digital reemplaza contratos, visitas y certificaciones con el banco." },
        { title: "Cumplimiento incluido", desc: "PCI DSS, 3-D Secure y antifraude ya están resueltos en nuestra plataforma." },
        { title: "Todos los métodos en un solo lugar", desc: "Tarjetas, Yappy, ACH y suscripciones con una única afiliación y un solo panel." },
      ],
      traditional: {
        label: "Adquirente tradicional",
        time: "3 a 6 semanas",
        steps: ["Solicitar reunión con el banco y negociar tarifas", "Contrato de afiliación y estudio de crédito", "Certificación técnica con el adquirente", "Instalación y homologación de cada método de pago"],
      },
      rapidpay: {
        label: "RapidPay PayFac",
        time: "24 a 48 horas",
        steps: ["Registro en línea en 4 pasos", "Carga digital de documentos", "Validación y activación de la cuenta", "Empieza a cobrar con todos los métodos"],
      },
      how: {
        label: "Cómo funciona",
        desc: "Tu cliente paga, RapidPay procesa como facilitador ante el adquirente y la marca, y tú recibes el cashout en tu banco local.",
        chain: ["Cliente", "RapidPay", "Adquirente / Marca", "Tu banco"],
      },
    },

    products: {
      title: "Todas las formas de cobrar",
      subtitle: "Con RapidPay tienes seis productos diseñados para que tu negocio nunca pierda una venta.",
      learnMore: "Conoce más",
      items: [
        { title: "Integración con plataformas", desc: "Integra RapidPay fácil y rápido con tu plataforma mediante API/Rest y Webhook, tu PMS y más. Pagos seguros sin redirecciones." },
        { title: "Link de pago y código QR", desc: "Recibe pagos en segundos sin necesidad de un sitio web; crea links de pago o códigos QR y compártelos por WhatsApp y redes sociales." },
        { title: "Cobros por suscripción", desc: "Automatiza el cobro mensual y crea planes según tu oferta de servicios. Tu cliente registra su tarjeta una sola vez." },
        { title: "Botón de pago y eCommerce", desc: "Agrega un botón de pago a tu tienda en línea y cobra en el checkout sin que el cliente salga de tu sitio. Confirmación instantánea para despachar al momento." },
        { title: "Sistema de Gestión de Cobros", desc: "Gestión de cobranzas inteligente por canales digitales como WhatsApp y email, con recordatorios automáticos. Tus clientes autogestionan sus pagos desde el enlace que reciben." },
        { title: "Suscripción de Servicios", desc: "Automatiza y gestiona el ciclo de vida completo de tus ingresos recurrentes. Vende servicios mediante cuotas periódicas mensuales, trimestrales o anuales, con cobro automático y control de renovaciones." },
      ],
    },
    checkoutDemo: {
      title: "Checkout RapidPay (demo)",
      subtitle: "Simulación de la experiencia de pago",
      secure: "Pago seguro",
      merchant: "Comercio",
      merchantName: "Tu Tienda Online",
      total: "Total",
      methods: { card: "Tarjeta", yappy: "Yappy", crypto: "Cripto" },
      email: "Email",
      emailPh: "tu@correo.com",
      plans: { monthly: "Mensual", quarterly: "Trimestral", yearly: "Anual" },
      subscribe: "Suscribirme",
      subscription: { label: "Suscripción", merchant: "Tu Negocio · Servicios", auto: "Cobro automático", nextRenewal: "Próxima renovación" },
      collection: { label: "Recordatorio de cobro · WhatsApp", text: "Hola María, tu factura #1042 de Tu Negocio está lista para pagar.", due: "Vence hoy", merchant: "Tu Negocio · Factura #1042" },
      cardNumber: "Número de tarjeta",
      expiry: "Vence",
      cvv: "CVV",
      yappyHint: "Confirma el pago en tu app Yappy desde tu celular.",
      cryptoHint: "Paga con stablecoins o cripto; el comercio recibe dólares.",
      pay: "Pagar",
      processing: "Procesando…",
      successTitle: "Pago aprobado",
      successDesc: "El comercio recibió la confirmación al instante.",
      amount: "Monto",
      reference: "Referencia",
      method: "Método",
      close: "Volver a la tienda",
      demoNote: "Demostración ilustrativa. No se realiza ningún cobro.",
    },

    industries: {
      title: "Cobrar no debería ser un dolor de cabeza",
      subtitle: "Cada industria enfrenta sus propios retos de cobro. Elige la tuya y mira cómo RapidPay los resuelve.",
      learnMore: "Conoce más",
      tabs: [
        {
          name: "Retail",
          headline: "Cada segundo en el checkout cuenta.",
          desc: "Una experiencia de pago compleja o lenta destruye tu conversión y pierde clientes en el último segundo.",
          bullets: [
            "Cobra con o sin sitio web: link de pago y código QR, o conexión con tu plataforma si ya vendes en línea.",
            "Todos los métodos de pago que tus clientes prefieren: tarjetas, Yappy y financiamiento a cuotas.",
            "Pagos sin redirecciones para menos carritos abandonados, con una de las tasas de aprobación más altas de la región.",
            "Reportes de ventas y catálogo de productos desde tu panel, para decidir con datos.",
          ],
        },
        {
          name: "Turismo",
          headline: "Reservas confirmadas al instante, desde cualquier país.",
          desc: "Tus huéspedes y viajeros pagan en su moneda y tú recibes en la tuya, sin fricción.",
          bullets: [
            "Acepta tarjetas internacionales y billeteras digitales de viajeros de todo el mundo.",
            "Integra tu motor de reservas o PMS sin conocimientos técnicos.",
            "Cobros anticipados y políticas de no-show con tokenización segura de tarjetas.",
            "Liquidación en dólares directo a tu cuenta local.",
          ],
        },
        {
          name: "Servicios",
          headline: "Automatiza tus cobros recurrentes y enfócate en tu negocio.",
          desc: "Desde gimnasios hasta consultoras: cobra suscripciones y facturas sin perseguir a nadie.",
          bullets: [
            "Planes de suscripción con cobro automático mensual, trimestral o anual.",
            "Links de pago para facturas puntuales que se pagan en segundos.",
            "Recordatorios y reintentos automáticos ante pagos fallidos.",
            "Panel con historial completo de cada cliente y su estado de pago.",
          ],
        },
        {
          name: "eCommerce",
          headline: "Vende en línea y cobra sin fricción.",
          desc: "Conecta tu tienda online y ofrece un checkout rápido y seguro que convierte más visitas en ventas.",
          bullets: [
            "Integración con tu tienda mediante API/Rest y Webhook, con documentación clara.",
            "Checkout embebido sin redirecciones: el cliente nunca sale de tu tienda.",
            "Acepta tarjetas, Yappy y cuotas en un solo botón de pago.",
            "Antifraude y confirmación instantánea para despachar pedidos al momento.",
          ],
        },
      ],
    },
    stats: {
      title: "Alcance regional, impacto local",
      subtitle: "Tu negocio cobra sobre la misma infraestructura de pagos que ya usan miles de comercios en Panamá y la región: tecnología propia, bancos locales y un equipo cerca de ti.",
      items: [
        { value: 15000, suffix: "+", label: "Comercios afiliados" },
        { value: 12, suffix: "", label: "Mercados en la región" },
        { value: 8, suffix: "M+", label: "Transacciones exitosas al año" },
        { value: 24, suffix: "+", label: "Bancos aliados en la región" },
      ],
    },
    pricing: {
      title: "Precios simples y transparentes",
      subtitle: "Sin mensualidades, sin costos ocultos, sin sorpresas. Una sola tarifa por transacción exitosa.",
      rateLabel: "Tarifa única",
      commission: "4%",
      commissionLabel: "Comisión por transacción",
      fixed: "$0.50",
      fixedLabel: "Costo por transacción",
      perTx: "por transacción exitosa",
      breakdown: [
        { label: "Comisión por transacción", value: "4%" },
        { label: "Costo por transacción", value: "$0.50" },
        { label: "Costo mensual", value: "$0" },
        { label: "Afiliación", value: "Gratis" },
      ],
      includedTitle: "Todo incluido en tu tarifa",
      included: [
        "Tarjetas Visa y Mastercard, locales e internacionales",
        "Pagos con Yappy",
        "Transferencias ACH",
        "Link de pago y código QR ilimitados",
        "Cobros por suscripción",
        "Cashout a tu Banco Local",
        "Panel de reportes y soporte local bilingüe",
      ],
      cta: "Comenzar ahora",
      note: "Aplica para transacciones exitosas. Para altos volúmenes, contáctanos y armamos una tarifa a tu medida.",
      calculator: {
        title: "Calculadora de costos",
        subtitle: "Escribe tu venta promedio y mira al instante cuánto recibirías.",
        inputLabel: "Transacción base",
        base: "Transacción base",
        commission: "Comisión RapidPay (4%)",
        fixedCost: "Costo por transacción",
        totalCost: "Total de costo",
        itbms: "ITBMS (7%) sobre el costo",
        net: "Total a recibir",
        netHint: "después de comisiones, costo por transacción y su ITBMS",
        disclaimer: "Cálculo estimado con fines ilustrativos. El ITBMS (7%) aplica únicamente sobre la comisión y el costo por transacción, no sobre el monto de la venta.",
      },
    },
    cta: {
      title: "¿Listo para cobrar sin límites?",
      subtitle: "Afíliate gratis y comienza a vender en 48 horas, o contáctanos si prefieres que te guiemos paso a paso.",
      primary: "Registrarme ahora",
      secondary: "Contáctenos",
    },
    testimonials: {
      title: "Negocios que decidieron crecer sus ventas con nosotros",
      items: [
        { quote: "Llevamos más de 3 años con RapidPay. Cuando necesitamos habilitar pagos con billeteras digitales, ellos ya lo tenían listo.", name: "Gabriela Mendoza", role: "Gerente de Canales Digitales" },
        { quote: "Un cliente que no puede completar su transacción es un cliente que probablemente no vuelve. Con RapidPay eso quedó completamente resuelto.", name: "Ricardo Batista", role: "CEO" },
        { quote: "Integramos nuestro motor de reservas en una tarde y sin programadores. La tasa de aprobación subió desde el primer mes.", name: "Laura Espino", role: "Directora" },
      ],
    },
    security: {
      title: "Cada transacción protegida",
      subtitle: "Los más altos niveles de seguridad internacional para que el dinero de tus clientes y tus cobros estén más que seguros.",
    },
    contact: {
      title: "Contáctenos",
      subtitle: "Estamos listos para ayudarte a empezar a cobrar. Escríbenos o visítanos.",
      addressLabel: "Dirección",
      emailLabel: "Correo",
      phoneLabel: "Teléfono",
      whatsappLabel: "WhatsApp",
      whatsappCta: "Escribir por WhatsApp",
      emailCta: "Enviar correo",
      callCta: "Llamar ahora",
    },
    footer: {
      tagline: "Payment Facilitator (PayFac) para Panamá y la región. Cobra rápido, vende sin límites.",
      products: "Productos",
      productLinks: ["Integración con plataformas", "Link de pago y QR", "Cobros por suscripción", "API y SDK"],
      company: "Empresa",
      companyLinks: ["Industrias", "Contacto"],
      resources: "Recursos",
      resourceLinks: ["Centro de ayuda"],
      legal: "Legal",
      legalLinks: ["Términos y condiciones", "Política de privacidad", "Cumplimiento PCI"],
      rights: "Todos los derechos reservados. RapidPay es un Payment Facilitator (PayFac).",
    },
  },
  en: {
    langName: "English",
    nav: { products: "Products", benefits: "Benefits", payfac: "PayFac", industries: "Industries", pricing: "Pricing", testimonials: "Clients", contact: "Contact", login: "Log in", signup: "Sign up" },
    hero: {
      chips: ["Retail", "Tourism", "Services", "eCommerce"],
      title1: "Getting paid has never",
      title2: "been this fast",
      subtitle: "RapidPay is a Payment Facilitator (PayFac) offering alternative payment methods in Panama, allowing merchants to reach a wider consumer base with instant payment confirmation.",
      ctaPrimary: "Get started",
      ctaSecondary: "Contact us",
      trusted: "Businesses already getting paid with RapidPay",
    },
    benefits: {
      title: "Everything you need to get paid without complications",
      items: [
        { title: "Free sign-up in 5 minutes", desc: "No lines or endless paperwork to start getting paid." },
        { title: "No fixed costs or monthly fees", desc: "You only pay when you sell. Simple as that." },
        { title: "Multiple payment methods", desc: "Local and international cards, local transfers, digital wallets, and installments.", showMethods: true },
        { title: "No banking bureaucracy", desc: "We handle the paperwork for you." },
        { title: "Get paid in the currency you prefer", desc: "Balboas or dollars, no complications." },
        { title: "Integration with no technical knowledge", desc: "+90 platforms ready to connect, or our own API and SDK." },
        { title: "Local bilingual technical support", desc: "Teams in the region, not a chatbot." },
        { title: "Cashout a tu Banco Local", desc: "More than 24 banks across Panama and the region." },
      ],
    },
    payfac: {
      label: "What is a PayFac?",
      title: "We are a Payment Facilitator: you onboard with us, not with the bank.",
      desc: "A Payment Facilitator (PayFac) is a company that already holds agreements with acquirers and card networks (Visa, Mastercard) and onboards merchants under its own master account. Instead of negotiating and certifying directly with a bank, the merchant signs up with RapidPay and starts getting paid.",
      desc2: "RapidPay handles technical certification, PCI compliance, fraud prevention and reconciliation, so you can focus on selling.",
      reasons: [
        { title: "Onboarding in hours, not weeks", desc: "We validate your data and documents online and activate your account fast." },
        { title: "Less paperwork", desc: "One digital sign-up replaces contracts, visits and certifications with the bank." },
        { title: "Compliance included", desc: "PCI DSS, 3-D Secure and fraud protection are already solved on our platform." },
        { title: "Every method in one place", desc: "Cards, Yappy, ACH and subscriptions with a single onboarding and one dashboard." },
      ],
      traditional: {
        label: "Traditional acquirer",
        time: "3 to 6 weeks",
        steps: ["Request a bank meeting and negotiate rates", "Merchant agreement and credit review", "Technical certification with the acquirer", "Setup and approval of each payment method"],
      },
      rapidpay: {
        label: "RapidPay PayFac",
        time: "24 to 48 hours",
        steps: ["Online sign-up in 4 steps", "Digital document upload", "Validation and account activation", "Start getting paid with every method"],
      },
      how: {
        label: "How it works",
        desc: "Your customer pays, RapidPay processes as facilitator with the acquirer and card network, and you receive the cashout in your local bank.",
        chain: ["Customer", "RapidPay", "Acquirer / Network", "Your bank"],
      },
    },

    products: {
      title: "Every way to get paid",
      subtitle: "With RapidPay you get six products designed so your business never loses a sale.",
      learnMore: "Learn more",
      items: [
        { title: "Platform integrations", desc: "Easily and quickly integrate RapidPay with your platform via API/Rest and Webhook, your PMS, and more. Secure payments with no redirects." },
        { title: "Payment link and QR code", desc: "Receive payments in seconds without a website; create payment links or QR codes and share them via WhatsApp and social media." },
        { title: "Subscription billing", desc: "Automate monthly billing and create plans based on your services. Your customer registers their card just once." },
        { title: "Payment button and eCommerce", desc: "Add a payment button to your online store and get paid at checkout without customers leaving your site. Instant confirmation so you can ship right away." },
        { title: "Collections Management System", desc: "Smart collections through digital channels such as WhatsApp and email, with automatic reminders. Your customers self-manage their payments from the link they receive." },
        { title: "Service Subscriptions", desc: "Automate and manage the full lifecycle of your recurring revenue. Sell services through periodic monthly, quarterly or yearly installments, with automatic billing and renewal control." },
      ],
    },
    checkoutDemo: {
      title: "RapidPay Checkout (demo)",
      subtitle: "Simulated payment experience",
      secure: "Secure payment",
      merchant: "Merchant",
      merchantName: "Your Online Store",
      total: "Total",
      methods: { card: "Card", yappy: "Yappy", crypto: "Crypto" },
      email: "Email",
      emailPh: "you@email.com",
      plans: { monthly: "Monthly", quarterly: "Quarterly", yearly: "Yearly" },
      subscribe: "Subscribe",
      subscription: { label: "Subscription", merchant: "Your Business · Services", auto: "Auto-billing", nextRenewal: "Next renewal" },
      collection: { label: "Payment reminder · WhatsApp", text: "Hi María, your invoice #1042 from Your Business is ready to pay.", due: "Due today", merchant: "Your Business · Invoice #1042" },
      cardNumber: "Card number",
      expiry: "Expiry",
      cvv: "CVV",
      yappyHint: "Confirm the payment in your Yappy app from your phone.",
      cryptoHint: "Pay with stablecoins or crypto; the merchant receives dollars.",
      pay: "Pay",
      processing: "Processing…",
      successTitle: "Payment approved",
      successDesc: "The merchant received instant confirmation.",
      amount: "Amount",
      reference: "Reference",
      method: "Method",
      close: "Back to store",
      demoNote: "Illustrative demo. No real charge is made.",
    },

    industries: {
      title: "Getting paid shouldn't be a headache",
      subtitle: "Every industry faces its own payment challenges. Pick yours and see how RapidPay solves them.",
      learnMore: "Learn more",
      tabs: [
        {
          name: "Retail",
          headline: "Every second at checkout counts.",
          desc: "A complex or slow payment experience destroys your conversion rate and loses customers at the very last second.",
          bullets: [
            "Get paid with or without a website: payment link and QR code, or platform connections if you already sell online.",
            "All the payment methods your customers prefer: cards, Yappy, and installment financing.",
            "Payments with no redirects for fewer abandoned carts, with one of the highest approval rates in the region.",
            "Sales reports and a product catalog from your dashboard, so you decide with data.",
          ],
        },
        {
          name: "Tourism",
          headline: "Bookings confirmed instantly, from any country.",
          desc: "Your guests and travelers pay in their currency and you receive in yours, friction-free.",
          bullets: [
            "Accept international cards and digital wallets from travelers worldwide.",
            "Integrate your booking engine or PMS with no technical knowledge.",
            "Advance charges and no-show policies with secure card tokenization.",
            "Settlement in dollars straight to your local account.",
          ],
        },
        {
          name: "Services",
          headline: "Automate your recurring billing and focus on your business.",
          desc: "From gyms to consulting firms: collect subscriptions and invoices without chasing anyone.",
          bullets: [
            "Subscription plans with automatic monthly, quarterly, or yearly billing.",
            "Payment links for one-off invoices paid in seconds.",
            "Automatic reminders and retries on failed payments.",
            "Dashboard with each client's full history and payment status.",
          ],
        },
        {
          name: "eCommerce",
          headline: "Sell online and get paid without friction.",
          desc: "Connect your online store and offer a fast, secure checkout that turns more visits into sales.",
          bullets: [
            "Integrate your store via API/Rest and Webhook, with clear documentation.",
            "Embedded checkout with no redirects: customers never leave your store.",
            "Accept cards, Yappy, and installments in a single payment button.",
            "Fraud protection and instant confirmation to ship orders right away.",
          ],
        },
      ],
    },
    stats: {
      title: "Regional reach, local impact",
      subtitle: "Your business gets paid on the same payment infrastructure thousands of merchants in Panama and the region already use: our own technology, local banks, and a team close to you.",
      items: [
        { value: 15000, suffix: "+", label: "Affiliated businesses" },
        { value: 12, suffix: "", label: "Markets across the region" },
        { value: 8, suffix: "M+", label: "Successful transactions per year" },
        { value: 24, suffix: "+", label: "Partner banks in the region" },
      ],
    },
    pricing: {
      title: "Simple, transparent pricing",
      subtitle: "No monthly fees, no hidden costs, no surprises. One single rate per successful transaction.",
      rateLabel: "Single rate",
      commission: "4%",
      commissionLabel: "Commission per transaction",
      fixed: "$0.50",
      fixedLabel: "Cost per transaction",
      perTx: "per successful transaction",
      breakdown: [
        { label: "Commission per transaction", value: "4%" },
        { label: "Cost per transaction", value: "$0.50" },
        { label: "Monthly fee", value: "$0" },
        { label: "Sign-up", value: "Free" },
      ],
      includedTitle: "Everything included in your rate",
      included: [
        "Visa and Mastercard, local and international",
        "Yappy payments",
        "ACH transfers",
        "Unlimited payment links and QR codes",
        "Subscription billing",
        "Cashout a tu Banco Local",
        "Reports dashboard and local bilingual support",
      ],
      cta: "Get started",
      note: "Applies to successful transactions. For high volumes, contact us and we'll tailor a rate for you.",
      calculator: {
        title: "Cost calculator",
        subtitle: "Type your average sale and instantly see how much you'd receive.",
        inputLabel: "Base transaction",
        base: "Base transaction",
        commission: "RapidPay commission (4%)",
        fixedCost: "Cost per transaction",
        totalCost: "Total cost",
        itbms: "ITBMS (7%) on fees",
        net: "Total you receive",
        netHint: "after commission, transaction cost and their ITBMS",
        disclaimer: "Estimate for illustrative purposes. ITBMS (7%) applies only to the commission and transaction cost, not to the sale amount.",
      },
    },
    cta: {
      title: "Ready to get paid without limits?",
      subtitle: "Sign up for free and start selling in 48 hours, or contact us if you'd rather we guide you step by step.",
      primary: "Sign up now",
      secondary: "Contact us",
    },
    testimonials: {
      title: "Businesses that chose to grow their sales with us",
      items: [
        { quote: "We've been with RapidPay for over 3 years. When we needed digital wallet payments, they already had it ready.", name: "Gabriela Mendoza", role: "Digital Channels Manager" },
        { quote: "A customer who can't complete their transaction is a customer who probably won't come back. With RapidPay that was completely solved.", name: "Ricardo Batista", role: "CEO" },
        { quote: "We integrated our booking engine in one afternoon, no developers needed. Our approval rate went up from the first month.", name: "Laura Espino", role: "Director" },
      ],
    },
    security: {
      title: "Every transaction protected",
      subtitle: "The highest levels of international security so your customers' money and your payments stay more than safe.",
    },
    contact: {
      title: "Contact us",
      subtitle: "We're ready to help you start getting paid. Write to us or visit us.",
      addressLabel: "Address",
      emailLabel: "Email",
      phoneLabel: "Phone",
      whatsappLabel: "WhatsApp",
      whatsappCta: "Chat on WhatsApp",
      emailCta: "Send email",
      callCta: "Call now",
    },
    footer: {
      tagline: "Payment Facilitator (PayFac) for Panama and the region. Get paid fast, sell without limits.",
      products: "Products",
      productLinks: ["Platform integrations", "Payment link & QR", "Subscription billing", "API & SDK"],
      company: "Company",
      companyLinks: ["Industries", "Contact"],
      resources: "Resources",
      resourceLinks: ["Help center"],
      legal: "Legal",
      legalLinks: ["Terms & conditions", "Privacy policy", "PCI compliance"],
      rights: "All rights reserved. RapidPay is a Payment Facilitator (PayFac).",
    },
  },
  pt: {
    langName: "Português",
    nav: { products: "Produtos", benefits: "Benefícios", payfac: "PayFac", industries: "Indústrias", pricing: "Preços", testimonials: "Clientes", contact: "Contato", login: "Entrar", signup: "Cadastre-se" },
    hero: {
      chips: ["Varejo", "Turismo", "Serviços", "eCommerce"],
      title1: "Receber nunca foi",
      title2: "tão rápido",
      subtitle: "A RapidPay é um Facilitador de Pagamentos (PayFac) que oferece métodos de pagamento alternativos no Panamá, permitindo que os comerciantes alcancem uma base de consumidores mais ampla com confirmação de pagamento instantânea.",
      ctaPrimary: "Começar agora",
      ctaSecondary: "Fale conosco",
      trusted: "Negócios que já recebem com RapidPay",
    },
    benefits: {
      title: "Tudo o que você precisa para receber sem complicações",
      items: [
        { title: "Cadastro grátis em 5 minutos", desc: "Sem filas nem papelada interminável para começar a receber." },
        { title: "Sem custos fixos nem mensalidades", desc: "Você só paga quando vende. Simples assim." },
        { title: "Múltiplos métodos de pagamento", desc: "Cartões nacionais e internacionais, transferências locais, carteiras digitais e parcelamento.", showMethods: true },
        { title: "Sem burocracia bancária", desc: "Nós cuidamos do processo por você." },
        { title: "Receba na moeda que preferir", desc: "Balboas ou dólares, sem complicações." },
        { title: "Integração sem conhecimento técnico", desc: "+90 plataformas prontas para conectar, ou nossa própria API e SDK." },
        { title: "Suporte técnico local e bilíngue", desc: "Equipes na região, não um chatbot." },
        { title: "Cashout a tu Banco Local", desc: "Mais de 24 bancos no Panamá e na região." },
      ],
    },
    payfac: {
      label: "O que é um PayFac?",
      title: "Somos um Facilitador de Pagamentos: você afilia com a gente, não com o banco.",
      desc: "Um Payment Facilitator (PayFac) é uma empresa que já possui contrato com os adquirentes e as bandeiras (Visa, Mastercard) e integra os comércios sob a sua própria conta mestre. Em vez de negociar e certificar-se diretamente com um banco, o comércio se cadastra na RapidPay e começa a receber.",
      desc2: "A RapidPay assume a certificação técnica, o cumprimento PCI, a prevenção de fraudes e a conciliação, para que você se concentre em vender.",
      reasons: [
        { title: "Afiliação em horas, não semanas", desc: "Validamos seus dados e documentos online e ativamos sua conta rapidamente." },
        { title: "Menos papelada", desc: "Um único cadastro digital substitui contratos, visitas e certificações com o banco." },
        { title: "Cumprimento incluído", desc: "PCI DSS, 3-D Secure e antifraude já estão resolvidos na nossa plataforma." },
        { title: "Todos os métodos em um só lugar", desc: "Cartões, Yappy, ACH e assinaturas com uma única afiliação e um único painel." },
      ],
      traditional: {
        label: "Adquirente tradicional",
        time: "3 a 6 semanas",
        steps: ["Solicitar reunião com o banco e negociar tarifas", "Contrato de afiliação e estudo de crédito", "Certificação técnica com o adquirente", "Instalação e homologação de cada método de pagamento"],
      },
      rapidpay: {
        label: "RapidPay PayFac",
        time: "24 a 48 horas",
        steps: ["Cadastro online em 4 passos", "Envio digital dos documentos", "Validação e ativação da conta", "Comece a receber com todos os métodos"],
      },
      how: {
        label: "Como funciona",
        desc: "Seu cliente paga, a RapidPay processa como facilitador junto ao adquirente e à bandeira, e você recebe o cashout no seu banco local.",
        chain: ["Cliente", "RapidPay", "Adquirente / Bandeira", "Seu banco"],
      },
    },

    products: {
      title: "Todas as formas de receber",
      subtitle: "Com a RapidPay você tem seis produtos criados para que seu negócio nunca perca uma venda.",
      learnMore: "Saiba mais",
      items: [
        { title: "Integração com plataformas", desc: "Integre a RapidPay fácil e rápido com sua plataforma via API/Rest e Webhook, seu PMS e mais. Pagamentos seguros sem redirecionamentos." },
        { title: "Link de pagamento e código QR", desc: "Receba pagamentos em segundos sem precisar de um site; crie links de pagamento ou códigos QR e compartilhe via WhatsApp e redes sociais." },
        { title: "Cobrança por assinatura", desc: "Automatize a cobrança mensal e crie planos conforme seus serviços. Seu cliente cadastra o cartão uma única vez." },
        { title: "Botão de pagamento e eCommerce", desc: "Adicione um botão de pagamento à sua loja virtual e receba no checkout sem que o cliente saia do seu site. Confirmação instantânea para despachar na hora." },
        { title: "Sistema de Gestão de Cobranças", desc: "Cobrança inteligente por canais digitais como WhatsApp e email, com lembretes automáticos. Seus clientes fazem a autogestão dos pagamentos pelo link que recebem." },
        { title: "Assinatura de Serviços", desc: "Automatize e gerencie o ciclo de vida completo das suas receitas recorrentes. Venda serviços por parcelas periódicas mensais, trimestrais ou anuais, com cobrança automática e controle de renovações." },
      ],
    },
    checkoutDemo: {
      title: "Checkout RapidPay (demo)",
      subtitle: "Simulação da experiência de pagamento",
      secure: "Pagamento seguro",
      merchant: "Loja",
      merchantName: "Sua Loja Online",
      total: "Total",
      methods: { card: "Cartão", yappy: "Yappy", crypto: "Cripto" },
      email: "Email",
      emailPh: "voce@email.com",
      plans: { monthly: "Mensal", quarterly: "Trimestral", yearly: "Anual" },
      subscribe: "Assinar",
      subscription: { label: "Assinatura", merchant: "Seu Negócio · Serviços", auto: "Cobrança automática", nextRenewal: "Próxima renovação" },
      collection: { label: "Lembrete de cobrança · WhatsApp", text: "Olá María, sua fatura #1042 de Seu Negócio está pronta para pagamento.", due: "Vence hoje", merchant: "Seu Negócio · Fatura #1042" },
      cardNumber: "Número do cartão",
      expiry: "Validade",
      cvv: "CVV",
      yappyHint: "Confirme o pagamento no app Yappy com o seu celular.",
      cryptoHint: "Pague com stablecoins ou cripto; a loja recebe em dólares.",
      pay: "Pagar",
      processing: "Processando…",
      successTitle: "Pagamento aprovado",
      successDesc: "A loja recebeu a confirmação instantaneamente.",
      amount: "Valor",
      reference: "Referência",
      method: "Método",
      close: "Voltar à loja",
      demoNote: "Demonstração ilustrativa. Nenhuma cobrança é realizada.",
    },

    industries: {
      title: "Receber não deveria ser uma dor de cabeça",
      subtitle: "Cada indústria enfrenta seus próprios desafios de cobrança. Escolha a sua e veja como a RapidPay os resolve.",
      learnMore: "Saiba mais",
      tabs: [
        {
          name: "Varejo",
          headline: "Cada segundo no checkout conta.",
          desc: "Uma experiência de pagamento complexa ou lenta destrói sua conversão e perde clientes no último segundo.",
          bullets: [
            "Receba com ou sem site: link de pagamento e código QR, ou conexão com sua plataforma se você já vende online.",
            "Todos os métodos de pagamento que seus clientes preferem: cartões, carteiras digitais e parcelamento.",
            "Pagamentos sem redirecionamentos para menos carrinhos abandonados, com uma das maiores taxas de aprovação da região.",
            "Relatórios de vendas e catálogo de produtos no seu painel, para decidir com dados.",
          ],
        },
        {
          name: "Turismo",
          headline: "Reservas confirmadas na hora, de qualquer país.",
          desc: "Seus hóspedes e viajantes pagam na moeda deles e você recebe na sua, sem atrito.",
          bullets: [
            "Aceite cartões internacionais e carteiras digitais de viajantes do mundo todo.",
            "Integre seu motor de reservas ou PMS sem conhecimento técnico.",
            "Cobranças antecipadas e políticas de no-show com tokenização segura de cartões.",
            "Liquidação em dólares direto na sua conta local.",
          ],
        },
        {
          name: "Serviços",
          headline: "Automatize suas cobranças recorrentes e foque no seu negócio.",
          desc: "De academias a consultorias: receba assinaturas e faturas sem correr atrás de ninguém.",
          bullets: [
            "Planos de assinatura com cobrança automática mensal, trimestral ou anual.",
            "Links de pagamento para faturas pontuais pagas em segundos.",
            "Lembretes e novas tentativas automáticas em pagamentos falhos.",
            "Painel com histórico completo de cada cliente e status de pagamento.",
          ],
        },
        {
          name: "eCommerce",
          headline: "Venda online e receba sem fricção.",
          desc: "Conecte sua loja virtual e ofereça um checkout rápido e seguro que converte mais visitas em vendas.",
          bullets: [
            "Integração com sua loja via API/Rest e Webhook, com documentação clara.",
            "Checkout embutido sem redirecionamentos: o cliente nunca sai da sua loja.",
            "Aceite cartões, Yappy e parcelamento em um único botão de pagamento.",
            "Antifraude e confirmação instantânea para despachar pedidos na hora.",
          ],
        },
      ],
    },
    stats: {
      title: "Alcance regional, impacto local",
      subtitle: "Seu negócio recebe sobre a mesma infraestrutura de pagamentos que milhares de comércios no Panamá e na região já usam: tecnologia própria, bancos locais e uma equipe perto de você.",
      items: [
        { value: 15000, suffix: "+", label: "Comércios afiliados" },
        { value: 12, suffix: "", label: "Mercados na região" },
        { value: 8, suffix: "M+", label: "Transações bem-sucedidas por ano" },
        { value: 24, suffix: "+", label: "Bancos parceiros na região" },
      ],
    },
    pricing: {
      title: "Preços simples e transparentes",
      subtitle: "Sem mensalidades, sem custos ocultos, sem surpresas. Uma única tarifa por transação bem-sucedida.",
      rateLabel: "Tarifa única",
      commission: "4%",
      commissionLabel: "Comissão por transação",
      fixed: "$0.50",
      fixedLabel: "Custo por transação",
      perTx: "por transação bem-sucedida",
      breakdown: [
        { label: "Comissão por transação", value: "4%" },
        { label: "Custo por transação", value: "$0.50" },
        { label: "Custo mensal", value: "$0" },
        { label: "Cadastro", value: "Grátis" },
      ],
      includedTitle: "Tudo incluído na sua tarifa",
      included: [
        "Visa e Mastercard, locais e internacionais",
        "Pagamentos com Yappy",
        "Transferências ACH",
        "Links de pagamento e códigos QR ilimitados",
        "Cobrança por assinatura",
        "Cashout a tu Banco Local",
        "Painel de relatórios e suporte local bilíngue",
      ],
      cta: "Começar agora",
      note: "Aplica-se a transações bem-sucedidas. Para altos volumes, fale conosco e criamos uma tarifa sob medida.",
      calculator: {
        title: "Calculadora de custos",
        subtitle: "Digite sua venda média e veja na hora quanto você receberia.",
        inputLabel: "Transação base",
        base: "Transação base",
        commission: "Comissão RapidPay (4%)",
        fixedCost: "Custo por transação",
        totalCost: "Custo total",
        itbms: "ITBMS (7%) sobre o custo",
        net: "Total a receber",
        netHint: "após comissão, custo por transação e seu ITBMS",
        disclaimer: "Cálculo estimado para fins ilustrativos. O ITBMS (7%) aplica-se apenas à comissão e ao custo por transação, não ao valor da venda.",
      },
    },
    cta: {
      title: "Pronto para receber sem limites?",
      subtitle: "Cadastre-se grátis e comece a vender em 48 horas, ou fale conosco se preferir que te guiemos passo a passo.",
      primary: "Cadastrar agora",
      secondary: "Fale conosco",
    },
    testimonials: {
      title: "Negócios que decidiram crescer suas vendas conosco",
      items: [
        { quote: "Estamos com a RapidPay há mais de 3 anos. Quando precisamos habilitar pagamentos com carteiras digitais, eles já tinham pronto.", name: "Gabriela Mendoza", role: "Gerente de Canais Digitais" },
        { quote: "Um cliente que não consegue concluir a transação é um cliente que provavelmente não volta. Com a RapidPay isso ficou completamente resolvido.", name: "Ricardo Batista", role: "CEO" },
        { quote: "Integramos nosso motor de reservas em uma tarde, sem programadores. A taxa de aprovação subiu desde o primeiro mês.", name: "Laura Espino", role: "Diretora" },
      ],
    },
    security: {
      title: "Cada transação protegida",
      subtitle: "Os mais altos níveis de segurança internacional para que o dinheiro dos seus clientes e seus recebimentos fiquem mais do que seguros.",
    },
    contact: {
      title: "Fale conosco",
      subtitle: "Estamos prontos para ajudar você a começar a receber. Escreva ou nos visite.",
      addressLabel: "Endereço",
      emailLabel: "E-mail",
      phoneLabel: "Telefone",
      whatsappLabel: "WhatsApp",
      whatsappCta: "Conversar no WhatsApp",
      emailCta: "Enviar e-mail",
      callCta: "Ligar agora",
    },
    footer: {
      tagline: "Payment Facilitator (PayFac) para o Panamá e a região. Receba rápido, venda sem limites.",
      products: "Produtos",
      productLinks: ["Integração com plataformas", "Link de pagamento e QR", "Cobrança por assinatura", "API e SDK"],
      company: "Empresa",
      companyLinks: ["Indústrias", "Contato"],
      resources: "Recursos",
      resourceLinks: ["Central de ajuda"],
      legal: "Legal",
      legalLinks: ["Termos e condições", "Política de privacidade", "Conformidade PCI"],
      rights: "Todos os direitos reservados. A RapidPay é um Payment Facilitator (PayFac).",
    },
  },
};
